import type { Locale } from '@croissants/i18n';
import type { JSX } from 'react';
import { useLocale } from '../state/locale';
import { FlagIcon } from './icons';

/**
 * The language switch required by PRD GST-006: ONE flag, one tap (founder,
 * 2026-09-18). It shows the language the page is IN - a control that reads as
 * the current state, like the two-word pill it replaced - and a tap moves to
 * the other. With two languages there is nothing to choose from, so there is
 * no menu to open.
 *
 * A real button, named for what a tap DOES and in the language it leads to
 * (`lang`), so a French reader who landed on an English page hears "Passer en
 * francais" rather than a flag (NFR-005). The flag itself is decoration.
 *
 * The chosen locale persists on the QR session and drives notifications
 * (NTF-004), so this is not a display preference and is not hidden in a settings
 * screen.
 */
export function LanguageSwitch(): JSX.Element {
  const { locale, setLocale, t } = useLocale();
  const other: Locale = locale === 'fr' ? 'en' : 'fr';

  return (
    <button
      type="button"
      className="gw-langswitch"
      lang={other}
      aria-label={other === 'fr' ? t('language.switchToFr') : t('language.switchToEn')}
      onClick={() => setLocale(other)}
    >
      <FlagIcon locale={locale} />
    </button>
  );
}
